export default "mutation signOut($refreshToken: String!) {\n\tsignOut(refreshToken: $refreshToken)\n}\n";